import { render, staticRenderFns } from "./PanelComment.vue?vue&type=template&id=1ff7e56a&scoped=true"
import script from "./PanelComment.vue?vue&type=script&lang=js"
export * from "./PanelComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff7e56a",
  null
  
)

export default component.exports